export default class BrowserMediaPermissionManager {
	static async requestBrowserMediaPermissions() {
		return await navigator.mediaDevices.getUserMedia({
			audio: true,
			video: true,
		});
	}

	static async browserHasCameraPermission() {
		const devices = await navigator.mediaDevices.enumerateDevices();

		return devices.some(
			(element) => element.label !== '' && element.kind === 'videoinput'
		);
	}

	static async browserHasMicrophonePermission() {
		const devices = await navigator.mediaDevices.enumerateDevices();

		return devices.some(
			(element) => element.label !== '' && element.kind === 'audioinput'
		);
	}
}
